import { cardPreferenceCenterPath, depositPath, paymentPath } from 'Modules/cardPayment/routes';
import { createFinancingPath } from 'Modules/financing/routes';

export const platformPaths = {
  DEPOSIT: depositPath,
  ADD_CARD: cardPreferenceCenterPath,
  PAYMENT: paymentPath,
  FINANCING: createFinancingPath,
};
